import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fmi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize FastAPI 422 validation errors (array of objects) into a string so toasts never render objects
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error?.response?.data;
    if (d && Array.isArray(d.detail)) {
      d.detail = d.detail.map((x) => (x?.msg ? `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`.replace(/^: /, "") : String(x))).join("; ");
    } else if (d && d.detail && typeof d.detail === "object") {
      d.detail = d.detail.msg || JSON.stringify(d.detail);
    }
    return Promise.reject(error);
  }
);


export const CURRENCIES = ["FMI", "BTC", "ETH", "USDT", "BNB", "SOL"];
export const CURRENCY_META = {
  FMI: { color: "#FFC107", label: "FMI", decimals: 2 },
  BTC: { color: "#F7931A", label: "BTC", decimals: 8 },
  ETH: { color: "#8A92B2", label: "ETH", decimals: 6 },
  USDT: { color: "#26A17B", label: "USDT", decimals: 2 },
  BNB: { color: "#F3BA2F", label: "BNB", decimals: 4 },
  SOL: { color: "#14F195", label: "SOL", decimals: 4 },
};

export const formatUsd = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatAmount = (amount, currency = "FMI") => {
  const d = CURRENCY_META[currency]?.decimals ?? 2;
  const num = Number(amount || 0);
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: d });
};

export const shortAddress = (addr) => (addr ? `${addr.slice(0, 6)}…${addr.slice(-4)}` : "");
